// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UAFunctionFunctionSetInner } from './UAFunctionFunctionSetInner';
import {
    UAFunctionFunctionSetInnerFromJSON,
    UAFunctionFunctionSetInnerFromJSONTyped,
    UAFunctionFunctionSetInnerToJSON,
    UAFunctionFunctionSetInnerToJSONTyped,
} from './UAFunctionFunctionSetInner';
import type { UAExclusiveLimitValues } from './UAExclusiveLimitValues';
import {
    UAExclusiveLimitValuesFromJSON,
    UAExclusiveLimitValuesFromJSONTyped,
    UAExclusiveLimitValuesToJSON,
    UAExclusiveLimitValuesToJSONTyped,
} from './UAExclusiveLimitValues';

/**
 * 
 * @export
 * @interface UAFunction
 */
export interface UAFunction {
    /**
     * 
     */
    browseName?: string;
    /**
     * Canonical source-side OPC UA browse path of this function (e.g. DeviceSet/Dev/FunctionalUnitSet/FU/FunctionSet/Fn). Nesting-safe; consumers use it 1:1 as the function identity.
     */
    browsePath?: string;
    /**
     * 
     */
    displayName?: string;
    /**
     * User-writable label (ComponentName). Consumers apply the chain
     * componentName -> displayName -> browseName.
     */
    componentName?: string | null;
    /**
     * Specifies the concrete LADS type of the Function
     */
    type?: string;
    /**
     * Complete OPC UA type hierarchy of the Function, ordered from the LADS
     * base type up to the concrete (possibly vendor-specific) type, e.g.
     * ["BaseControlFunctionType", "AnalogControlFunctionType", "PumpStageSelectorType"].
     * The first element is suited for selecting a generic UI component, the
     * last element is the device-defined concrete type.
     * @type {Array<string>}
     * @memberof UAFunction
     */
    typeHierarchy?: Array<string>;
    /**
     * 
     */
    functionSet?: Array<UAFunctionFunctionSetInner>;
    /**
     * Configuration is used to organize parameters for
     * configuration of the Function.
     */
    _configuration?: object;
    /**
     * Physical port identifier for this Function (e.g. "left", "right", "first").
     * Maps to the OPC UA Port property on the Function node.
     */
    port?: string | null;
    /**
     * IsEnabled indicates whether the Function can currently be executed on the Device.
     * A Function may be disabled for several reasons including not licensed,
     * missing hardware modules, or missing supplies
     */
    isEnabled?: boolean;
    /**
     * 
     */
    alarmMonitor?: UAExclusiveLimitValues;
}

/**
 * Check if a given object implements the UAFunction interface.
 */
export function instanceOfUAFunction(value: object): value is UAFunction {
    return true;
}

export function UAFunctionFromJSON(json: any): UAFunction {
    return UAFunctionFromJSONTyped(json, false);
}

export function UAFunctionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAFunction {
    if (json == null) {
        return json;
    }
    return {
        
        'browseName': json['browseName'] == null ? undefined : json['browseName'],
        'browsePath': json['browsePath'] == null ? undefined : json['browsePath'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'componentName': json['componentName'] == null ? undefined : json['componentName'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeHierarchy': json['typeHierarchy'] == null ? undefined : json['typeHierarchy'],
        'functionSet': json['functionSet'] == null ? undefined : ((json['functionSet'] as Array<any>).map(UAFunctionFunctionSetInnerFromJSON)),
        '_configuration': json['configuration'] == null ? undefined : json['configuration'],
        'port': json['port'] === undefined ? undefined : json['port'] === null ? null : json['port'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'alarmMonitor': json['alarmMonitor'] == null ? undefined : UAExclusiveLimitValuesFromJSON(json['alarmMonitor']),
    };
}

export function UAFunctionToJSON(json: any): UAFunction {
    return UAFunctionToJSONTyped(json, false);
}

export function UAFunctionToJSONTyped(value?: UAFunction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browseName': value['browseName'],
        'browsePath': value['browsePath'],
        'displayName': value['displayName'],
        'componentName': value['componentName'],
        'type': value['type'],
        'typeHierarchy': value['typeHierarchy'],
        'functionSet': value['functionSet'] == null ? undefined : ((value['functionSet'] as Array<any>).map(UAFunctionFunctionSetInnerToJSON)),
        'configuration': value['_configuration'],
        'port': value['port'],
        'isEnabled': value['isEnabled'],
        'alarmMonitor': UAExclusiveLimitValuesToJSON(value['alarmMonitor']),
    };
}

